/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
import styled from 'styled-components'

export const Container = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	height: 100%;
`
export const Content = styled.main`
	flex: 1;
	overflow: auto;
`
